import { getPureTenantUrl, getTenant } from '@cloud/shared';
import { useCallback, useState } from 'react';

import Icon from '@ovpn/ui/icon';
import { color } from '@ovpn/ui/tokens';
import Tooltip from '@ovpn/ui/tooltip';

import {
    Container,
    CopyTenant,
    CurrentTenant,
    IconContainer,
    NoWrap,
} from './SingleTenantBanner.styles';

export function SingleTenantBanner() {
    const content = 'openvpn.com';
    const activeTenant = getTenant();

    const [isCopied, setIsCopied] = useState(false);

    const handleCopy = useCallback(
        (e: React.MouseEvent<HTMLDivElement>) => {
            e.stopPropagation();
            e.preventDefault();

            setIsCopied(true);
            navigator.clipboard.writeText(getPureTenantUrl(activeTenant));
        },
        [activeTenant],
    );

    const handleTooltipChange = useCallback((opened: boolean) => {
        if (!opened) {
            setIsCopied(false);
        }
    }, []);

    return (
        <Container>
            <IconContainer>
                <Icon name="cloud" />
            </IconContainer>
            <CurrentTenant className="user-info">
                <NoWrap size="textSm" weight="medium" className="user-info-tenant">
                    {activeTenant}
                </NoWrap>
                {content && (
                    <NoWrap
                        size="textSm"
                        weight="regular"
                        style={{ color: color.neutral.border.var }}
                    >
                        {content}
                    </NoWrap>
                )}
            </CurrentTenant>
            <Tooltip
                placement="top"
                onChange={handleTooltipChange}
                trigger={
                    <CopyTenant onClick={handleCopy} $copied={isCopied}>
                        <Icon name="circle-check" className="icon-copied" />
                        <Icon name="copy" className="icon-copy" />
                    </CopyTenant>
                }
            >
                {isCopied ? 'Copied!' : 'Copy Cloud ID'}
            </Tooltip>
        </Container>
    );
}
